module.exports = __webpack_public_path__ + "static/media/play-lamp-left.017f1289.png";